import { ReduxActions } from '../constants/redux_actions';
import { ApplicationState } from '../helpers/app_state';
import { ActionsUnion, createAction } from './actions_helper';

export const bannerPreferencesReducerName = 'bannerPreferences';
export type bannerPreferencesReducerType = typeof initialState;

export const BannerKeys = {
  CATALOG: 'catalog',
  MAP: 'map',
  PDP: 'pdp',
  WATERBODY_CURRENT_CONDITIONS: 'waterbody_current_conditions',
  WATERBODY_FISHING_PATTERNS: 'waterbody_fishing_patterns',
  WATERBODY_FISHING_REPORTS: 'waterbody_fishing_reports',
} as const;
export type BannerKeys = typeof BannerKeys[keyof typeof BannerKeys];

export enum StateKeys {
  hidden = 'hidden',
}

export const initialState = {
  [StateKeys.hidden]: [] as BannerKeys[],
};

// ========================================================================== //
// Selectors
// ========================================================================== //
export const getBannerPrefsHidden = (state: ApplicationState) =>
  state[bannerPreferencesReducerName][StateKeys.hidden];

// ========================================================================== //
// Reducer
// ========================================================================== //

export function BannerPreferencesReducer(
  state = initialState,
  action: BannerPreferencesActions
): bannerPreferencesReducerType {
  switch (action.type) {
    case ReduxActions.BANNER_PREFERENCES_HIDDEN_SAVE: {
      const hidden = state[StateKeys.hidden];
      const alreadyHidden = hidden.includes(action.payload);
      if (alreadyHidden) {
        return state;
      }

      return {
        ...state,
        [StateKeys.hidden]: state[StateKeys.hidden].concat(action.payload),
      };
    }

    default:
      return state;
  }
}

// ========================================================================== //
// Actions
// ========================================================================== //

export const BannerPreferencesActions = {
  BANNER_PREFERENCES_HIDDEN_SAVE: (key: BannerKeys) =>
    createAction(ReduxActions.BANNER_PREFERENCES_HIDDEN_SAVE, key),
};
export type BannerPreferencesActions = ActionsUnion<typeof BannerPreferencesActions>;
